"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteTransaction = exports.getTransactionsByOrderId = exports.getTransactionItems = exports.getTransaction = exports.getTransactionsBySupplierId = exports.getTransactions = void 0;
const getTransactions = async (supabase) => {
    const { data, error } = await supabase.rpc("get_transactions");
    if (!error)
        return data;
    return error;
};
exports.getTransactions = getTransactions;
const getTransactionsBySupplierId = async (supabase, id) => {
    const { data, error } = await supabase.rpc("get_transactions_by_supplier_id", {
        s_id: id,
    });
    if (!error)
        return data;
    return error;
};
exports.getTransactionsBySupplierId = getTransactionsBySupplierId;
const getTransaction = async (supabase, id) => {
    const { data, error } = await supabase.rpc("get_transaction_by_id", {
        t_id: id,
    });
    if (!error)
        return data[0];
    return error;
};
exports.getTransaction = getTransaction;
const getTransactionItems = async (supabase, id) => {
    const { data, error } = await supabase.rpc("get_transaction_items_by_id", {
        t_id: id,
    });
    if (!error)
        return data;
    return error;
};
exports.getTransactionItems = getTransactionItems;
const getTransactionsByOrderId = async (supabase, id) => {
    const { data, error } = await supabase.rpc("get_transactions_by_order_id", {
        o_id: id,
    });
    if (!error)
        return data;
    return error;
};
exports.getTransactionsByOrderId = getTransactionsByOrderId;
const deleteTransaction = async (supabase, id) => {
    const { data, error } = await supabase
        .from("transactions")
        .delete()
        .eq("id", id);
    if (!error)
        return data;
    return error;
};
exports.deleteTransaction = deleteTransaction;
